import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

const TEKST = {
  kop: { nl: 'Productsheet', en: 'Product sheet' },
  uitleg: { nl: 'Scan en lees verder op je telefoon', en: 'Scan and keep reading on your phone' },
}

/**
 * De korte URL die de QR codeert. Op de kiosk is dat het domein van de
 * Worker; de bezoeker opent hem met de mobiele data van zijn eigen telefoon,
 * dus de dekking van het beursnetwerk doet er niet toe (PLAN.md §0.1).
 *
 * In het schijfpakket (docs/schijfpakket.md) draait de kiosk op
 * `localhost`, en daar kan geen telefoon heen: dan zet de bouw het online
 * adres in `VITE_PUBLIEKE_URL`.
 */
const PUBLIEK: string | undefined = import.meta.env.VITE_PUBLIEKE_URL
export const sheetUrl = (sheet: string): string => `${PUBLIEK || window.location.origin}/s/${sheet}`

/**
 * QR-code naar de productsheet van een machine (feedback 5 oktober).
 *
 * Een kiosk kan niets downloaden, dus "makkelijk te downloaden" betekent hier:
 * scannen en op je telefoon openen. De code wordt lokaal gegenereerd — geen
 * dienst, geen netwerk — als SVG, zodat hij op elk paneel scherp blijft.
 * Foutcorrectie M: de code staat achter glas met vingerafdrukken, en een
 * kwart beschadiging mag hij hebben.
 */
export function ProductsheetQR({ sheet, taal, compact = false, kop }: {
  sheet: string
  taal: 'nl' | 'en'
  compact?: boolean
  /** Kop naast de code, al vertaald; standaard "Productsheet". Stellingen zegt "Brochure". */
  kop?: string
}) {
  const [svg, setSvg] = useState<string | null>(null)
  const url = sheetUrl(sheet)

  useEffect(() => {
    let actief = true
    QRCode.toString(url, { type: 'svg', errorCorrectionLevel: 'M', margin: 0 })
      .then((s) => { if (actief) setSvg(s) })
      .catch((e: unknown) => console.warn('[productsheet] QR mislukt:', e))
    return () => { actief = false }
  }, [url])

  return (
    <div className={`qr${compact ? ' qr-compact' : ''}`} aria-label={`${kop ?? TEKST.kop[taal]}: ${url}`}>
      {/* Uitvoer van de qrcode-bibliotheek, geen bezoekersinvoer. */}
      <div className="qr-code" dangerouslySetInnerHTML={{ __html: svg ?? '' }} />
      <div className="qr-tekst">
        <strong>{kop ?? TEKST.kop[taal]}</strong>
        <span>{TEKST.uitleg[taal]}</span>
        <code>{url.replace(/^https?:\/\//, '')}</code>
      </div>
    </div>
  )
}
